import { useState, useEffect } from "react";
import "../../../App.css";
import { MapContainer } from "../../../assets/style";
import Map from "../../../components/MapsForEntry";
import { EntryContext, useSubState } from "../shared/State";

export const MapDiv = () => {
  const [entryContext, workerStatus] = useSubState(
    EntryContext!,
    (x) => x.realTimeStatus.workerStatuses!
  );
  const [workerCount, setWorkerCount] = useState(1);

  // Log worker status for debugging
  useEffect(() => {
    console.log("=== MapDiv Debug ===");
    console.log("Worker Status:", workerStatus);
    if (Array.isArray(workerStatus)) {
      workerStatus.forEach((worker: any, index: number) => {
        console.log(`Worker ${index}:`, {
          name: worker?.name,
          type: worker?.type,
          position: worker?.position,
          realTimeResourceTypeId: worker?.realTimeResourceTypeId,
          showGasGPS: worker?.showGasGPS,
          showWatchGPS: worker?.showWatchGPS,
        });
      });
    } else {
      console.warn("Worker status is not an array:", workerStatus);
    }
  }, [workerStatus]);

  return (
    <MapContainer style={{ width: "100%", height: "100%" }}>
      <Map
        selectPosition={workerStatus}
        setSelectPosition={() => {}}
        zoom={17}
        workerCount={workerCount}
        status={workerStatus}
        scrollWheelZoom={"center"}
      />
    </MapContainer>
  );
};
